import { Injectable } from '@angular/core';
import { DialogService, DialogRef } from 'src/app/components/dialog';

import { StatefulLoadingComponent } from 'src/app/components/stateful-loading/stateful-loading.component';
import { SnackbarService } from 'src/app/components/snackbar/snackbar.service';
import { SnackbarData } from 'src/app/components/snackbar/snackbar.types';

@Injectable({
  providedIn: 'root',
})
export class SaveService {
  loader: DialogRef<StatefulLoadingComponent>;

  constructor(
    private dialog: DialogService,
    private snackbarService: SnackbarService
  ) {}

  initLoader(loaderMessage: string): void {
    this.loader = StatefulLoadingComponent.open(
      this.dialog,
      {
        title: 'Por favor, aguarde',
        content: loaderMessage,
      },
      { width: '500px', disableClose: true }
    );
  }

  initSnackBar(success: boolean, message: string): void {
    this.snackbarService.status({
      message,
      action: 'Fechar',
      ...this.getSnackBarData(success),
    });
  }

  private getSnackBarData(
    success: boolean
  ): Pick<SnackbarData, 'state' | 'icon'> {
    return success
      ? {
          state: 'ok',
          icon: 'check',
        }
      : {
          state: 'error',
        };
  }
}
